module.exports = __webpack_public_path__ + "img/Layer 13.a2408f61.svg";